// extracted by mini-css-extract-plugin
export default {"image-preview":"image-preview--Ip4vF","image-wrapper":"image-wrapper--TiF9u"};